let total_accounts = 100
let temp = 100
let check = false
let total_order_video_records = 0
let submit_form = false

$(".order-video-answers").sortable({ cancel: ".answer" })

$(document).ready(function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#order_video_page_neutral",
    fieldVisualFeedback: "#order_video_page_visual_feedback",
    fieldMandatoryCorrect: "#order_video_page_mandatory_correct",
  })

  if (document.getElementById("order_video_page_page_attributes_score") == undefined) {
    return
  }

  const order_video_answer_file_limits =
    $("#order_video_answer_file_limits").val() && JSON.parse($("#order_video_answer_file_limits").val())

  $("#new_order_video_page").submit(function (e) {
    if ($("#order_video_page_page_attributes_name").val() == "") {
      alert("Name can't be blank")
      e.preventDefault()
      return false
    }
  })

  if (document.getElementById("new_order_video_page") == undefined) {
    total_order_video_records = $(".order-video-answers").children().length / 2
  }

  document.addEventListener("assetSelected", function (e) {
    const { url, targetField, videoSubtitlesUrl, videoThumbnailImageUrl, id } = e.detail
    let asset_id = id

    if (targetField && targetField.startsWith("order_video_")) {
      const [_, objectId, languageId] = targetField.split("_")
      const filePreview = $(`.answers-for-${languageId}`).find(
        `[data-object-id="${objectId}"] .upload-order-video-preview video`,
      )
      const fileName = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_name`)
      const fileType = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] #file_type`)
      const assetId = $(`.answers-for-${languageId}`).find(`[data-object-id="${objectId}"] .asset_id`)
      assetId.val(asset_id)
      if (filePreview.length > 0) {
        const sourceElement = filePreview.find("source")
        if (sourceElement.length > 0) {
          sourceElement.attr("src", `/s3-proxy?url=${encodeURIComponent(url)}`)
        } else {
          filePreview.html(
            `<source src="/s3-proxy?url=${encodeURIComponent(url)}" type="video/mp4">Your browser does not support the video tag.`,
          )
        }

        if (videoThumbnailImageUrl) {
          filePreview.attr("poster", `/s3-proxy?url=${encodeURIComponent(videoThumbnailImageUrl)}`)
        }

        if (videoSubtitlesUrl) {
          const track = document.createElement("track")
          track.kind = "subtitles"
          track.label = "English"
          track.srclang = "en"
          track.src = `/s3-proxy?url=${encodeURIComponent(videoSubtitlesUrl)}`
          track.default = true
          filePreview[0].appendChild(track)
        }

        const fileNameFromUrl = url.split("/").pop()
        fileName.val(fileNameFromUrl)
        fileType.val("video/mp4")

        filePreview.parent().css("display", "block")
        filePreview.parent().parent().parent().css("display", "block")

        filePreview[0].load()
      }
    } else if (targetField && targetField.startsWith("new_answer_")) {
      const languageId = targetField.split("_")[2]

      if (window.orderVideoFieldsData) {
        add_order_video_fields(null, window.orderVideoAssociation, window.orderVideoFieldsData, "new")

        setTimeout(function () {
          const lastAnswer = $(".answers-for-" + languageId)
            .children()
            .last()
          const filePreview = lastAnswer.find(".upload-order-video-preview video")
          const fileName = lastAnswer.find("#file_name")
          const fileType = lastAnswer.find("#file_type")
          const assetId = lastAnswer.find(".asset_id")
          assetId.val(asset_id)

          if (filePreview.length > 0) {
            const videoEl = filePreview[0]
            const sourceElement = filePreview.find("source")
            if (sourceElement.length > 0) {
              sourceElement.attr("src", `/s3-proxy?url=${encodeURIComponent(url)}`)
            } else {
              filePreview.html(
                `<source src="/s3-proxy?url=${encodeURIComponent(url)}" type="video/mp4">Your browser does not support the video tag.`,
              )
            }

            if (videoThumbnailImageUrl) {
              filePreview.attr("poster", `/s3-proxy?url=${encodeURIComponent(videoThumbnailImageUrl)}`)
            }

            if (videoSubtitlesUrl) {
              const track = document.createElement("track")
              track.kind = "subtitles"
              track.label = "English"
              track.srclang = "en"
              track.src = `/s3-proxy?url=${encodeURIComponent(videoSubtitlesUrl)}`
              track.default = true
              filePreview[0].appendChild(track)
            }

            const fileNameFromUrl = url.split("/").pop()
            fileName.val(fileNameFromUrl)
            fileType.val("video/mp4")

            filePreview.parent().css("display", "block")
            lastAnswer.css("display", "block")

            videoEl.muted = true
            videoEl.setAttribute("muted", "")

            filePreview[0].load()
          }
        }, 100)
      } else {
        console.error("No stored fields data for new answer")
      }
    }

    window.orderVideoFieldsData = null
    window.useAssetLibrary = null
    window.orderVideoAssociation = null
    window.orderVideoView = null

    $("input, button, a").prop("disabled", false)

    document.body.offsetHeight
  })

  $(document).on("click", '.add-order-video-answer[data-action="open-choose-from-library"]', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $link = $(this)
    const action = $link.data("action")
    const useAssetLibrary = $link.data("use-asset-library")
    const actionTarget = $link.data("action-target")

    console.log("Asset library add order video answer clicked:", {
      action,
      useAssetLibrary,
      actionTarget,
      element: this,
      dataAttributes: $link.data(),
    })

    const fields = $("#fields_data_" + $("#page_language_selection").val()).val()
    window.orderVideoFieldsData = fields
    window.useAssetLibrary = true
    window.orderVideoAssociation = $link.data("association")
    window.orderVideoView = $link.data("view")

    return true
  })

  $(document).on("click", '.add-order-video-answer:not([data-action="open-choose-from-library"])', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const $link = $(this)
    const action = $link.data("action")
    const useAssetLibrary = $link.data("use-asset-library")
    const actionTarget = $link.data("action-target")

    console.log("Direct upload add order video answer clicked:", {
      action,
      useAssetLibrary,
      actionTarget,
      element: this,
      dataAttributes: $link.data(),
    })

    window.orderVideoFieldsData = null
    window.useAssetLibrary = false
    window.orderVideoAssociation = null
    window.orderVideoView = null

    const fields = $link.data("fields") || $link.closest(".fields-data-container").data("fields")
    const association = $link.data("association") || "order_video_answers"
    const view = $link.data("view") || "new"

    if (fields) {
      const tempLink = $("<div>").addClass("temp-direct-upload")
      add_order_video_fields(tempLink[0], association, fields, view)
    } else {
      console.error("No fields data found for direct upload")
    }

    return false
  })
})

function order_video_preview() {
  let language = $("#page_language_selection").val()
  let file_preview = $(".answers-for-" + language)
    .children()
    .last()
    .find(".upload-order-video-preview video")
  let file_name = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_name")
  let file_type = $(".answers-for-" + language)
    .children()
    .last()
    .find("#file_type")

  const useAssetLibrary = $(".answers-for-" + language)
    .children()
    .last()
    .find(".add-answer-container")
    .data("use-asset-library")
  if (!useAssetLibrary) {
    const fileInput = $(".answers-for-" + language)
      .children()
      .last()
      .find(".order-vid-preview")

    fileInput.off("change")

    fileInput.change(function (event) {
      let file, input, reader
      $(".answers-for-" + language)
        .children()
        .last()
        .find(".upload-order-video-preview")
        .css("display", "block")
      $(".answers-for-" + language)
        .children()
        .last()
        .css("display", "block")
      input = $(event.currentTarget)
      file = input[0].files[0]
      const order_video_answer_file_limits =
        $("#order_video_answer_file_limits").val() && JSON.parse($("#order_video_answer_file_limits").val())
      if (fileSizeNotInLimit(file, event, ".edit-banner-modal", order_video_answer_file_limits["video"])) {
        input.val("")
        check_last_order_video_answer()
        return
      } else {
        reader = new FileReader()
        reader.onload = function (e) {
          let video_base64
          video_base64 = e.target.result
          video_base64 = video_base64.replace("quicktime", "mp4")

          const sourceElement = file_preview.find("source")
          if (sourceElement.length > 0) {
            sourceElement.attr("src", video_base64)
          } else {
            file_preview.html(
              `<source src="${video_base64}" type="video/mp4">Your browser does not support the video tag.`,
            )
          }

          $(file_name).val(file.name)
          $(file_type).val(file.type)

          file_preview[0].load()
        }
        reader.readAsDataURL(file)
      }
    })

    fileInput.click()
  }
}

window.remove_order_video_fields = function (link) {
  $(link).siblings().val(1)
  $(link).parent().parent().remove()
  total_order_video_records--
}

function check_last_order_video_answer() {
  let language = $("#page_language_selection").val()
  if (
    $(".answers-for-" + language)
      .children()
      .last()
      .find(".order-vid-preview")
      .val() == ""
  ) {
    $(".answers-for-" + language)
      .children()
      .last()
      .remove()
    total_order_video_records--
  }
}

window.add_order_video_fields = function (link, association, fields_to_clone, view) {
  if (!window.useAssetLibrary) {
    check_last_order_video_answer()
  }

  const $link = $(link)

  if (window.useAssetLibrary) {
    association = window.orderVideoAssociation || association
    view = window.orderVideoView || view
    fields_to_clone = window.orderVideoFieldsData
  }

  const useAssetLibrary =
    window.useAssetLibrary || $link.data("use-asset-library") || $link.closest(".add-answer-container").length > 0

  console.log("Adding order video fields:", {
    useAssetLibrary,
    hasFieldsToClone: !!fields_to_clone,
    hasStoredData: !!window.orderVideoFieldsData,
    association,
    view,
  })

  // Try to get fields data in this order:
  // 1. From the passed fields_to_clone parameter
  // 2. From the stored global variable (only if using asset library)
  // 3. From the hidden input field
  // 4. From the container's data attribute
  if (!fields_to_clone) {
    fields_to_clone =
      window.orderVideoFieldsData ||
      $("#fields_data_" + $("#page_language_selection").val()).val() ||
      $link.closest(".fields-data-container").data("fields") ||
      $link.data("fields")

    console.log("Fields data sources:", {
      fromGlobal: !!window.orderVideoFieldsData,
      fromHidden: !!$("#fields_data_" + $("#page_language_selection").val()).val(),
      fromContainer: !!$link.closest(".fields-data-container").data("fields"),
      fromLink: !!$link.data("fields"),
      fieldsDataLength: fields_to_clone ? fields_to_clone.length : 0,
    })
  }

  if (!fields_to_clone) {
    return
  }

  if (total_order_video_records < 4) {
    total_order_video_records++
  }

  if (view == "new") {
    total_accounts++
  } else {
    temp++
    total_accounts = temp
  }

  let language = $("#page_language_selection").val()
  let course_default_language = $("#course_default_language").val()
  let add_answer =
    course_default_language == language ||
    $(".answers-for-" + language).children().length < $(".answers-for-" + course_default_language).children().length

  if (add_answer) {
    try {
      let replacedFields = fields_to_clone
      let regexp = new RegExp(`\\[new_${association}\\]`, "g")
      replacedFields = replacedFields.replace(regexp, `[${total_accounts}]`)

      $(".answers-for-" + language).append(replacedFields)

      if (!useAssetLibrary) {
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        const fileInput = lastAnswer.find(".order-vid-preview")
        const filePreview = lastAnswer.find(".upload-order-video-preview video")
        const fileName = lastAnswer.find("#file_name")
        const fileType = lastAnswer.find("#file_type")

        fileInput.off("change")

        fileInput.change(function (event) {
          let file, input, reader
          lastAnswer.find(".upload-order-video-preview").css("display", "block")
          lastAnswer.css("display", "block")
          input = $(event.currentTarget)
          file = input[0].files[0]
          const order_video_answer_file_limits =
            $("#order_video_answer_file_limits").val() && JSON.parse($("#order_video_answer_file_limits").val())
          if (fileSizeNotInLimit(file, event, ".edit-banner-modal", order_video_answer_file_limits["video"])) {
            input.val("")
            check_last_order_video_answer()
            return
          } else {
            reader = new FileReader()
            reader.onload = function (e) {
              let video_base64
              video_base64 = e.target.result
              video_base64 = video_base64.replace("quicktime", "mp4")

              const sourceElement = filePreview.find("source")
              if (sourceElement.length > 0) {
                sourceElement.attr("src", video_base64)
              } else {
                filePreview.html(
                  `<source src="${video_base64}" type="video/mp4">Your browser does not support the video tag.`,
                )
              }

              $(fileName).val(file.name)
              $(fileType).val(file.type)

              filePreview[0].load()
            }
            reader.readAsDataURL(file)
          }
        })

        setTimeout(() => {
          if ($("#asset_library_allowed").val() == "false") {
            fileInput.click()
          }
        }, 100)
      } else {
        const lastAnswer = $(".answers-for-" + language)
          .children()
          .last()
        lastAnswer.find(".upload-order-video-preview").css("display", "block")
        lastAnswer.css("display", "block")
      }
    } catch (e) {
      console.error("Error adding new answer fields:", e)
    }
  } else {
    alert("Can't add more answers in this language as it exceeds the number of answers added in default language")
  }

  if (!useAssetLibrary) {
    window.orderVideoFieldsData = null
    window.useAssetLibrary = null
    window.orderVideoAssociation = null
    window.orderVideoView = null
  }
}

$("#order_video_page_mandatory_correct").on("click", function () {
  if ($("#order_video_page_mandatory_correct").is(":checked")) {
    if (!$("#order_video_page_feedback").is(":checked")) {
      $("#order_video_page_feedback").click()
    }
    if ($("#order_video_page_neutral").is(":checked")) {
      $("#order_video_page_neutral").click()
    }
  }
})

$("#order_video_page_neutral").on("click", function () {
  influence_visual_feedback_and_mandatory_correct_for_interactive_page({
    fieldNeutral: "#order_video_page_neutral",
    fieldVisualFeedback: "#order_video_page_visual_feedback",
    fieldMandatoryCorrect: "#order_video_page_mandatory_correct",
  })
})

$("#order_video_page_feedback").on("click", function () {
  if (!$("#order_video_page_feedback").is(":checked")) {
    if ($("#order_video_page_mandatory_correct").is(":checked")) {
      $("#order_video_page_mandatory_correct").click()
    }
  }
})

$('form[id="new_order_video_page"]').submit(function (e) {
  if (submit_form === false) {
    e.preventDefault()
    submit_form = true
  } else {
    submit_form = false
    return
  }
  $(this).submit()
  $("#loading-modal").openModal({ dismissible: false })
})

$('form[id^="edit_order_video_page_"]').submit(function (e) {
  if (submit_form === false) {
    e.preventDefault()
    submit_form = true
  } else {
    submit_form = false
    return
  }
  $(this).submit()
  $("#loading-modal").openModal({ dismissible: false })
})
